import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgViking = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.657 4.436a.75.75 0 0 0-1.409.132A8.4 8.4 0 0 0 2 6.625c0 2.345.975 4.473 2.553 6.076a6.45 6.45 0 0 0-.817 3.148v2.879c0 .414.335.75.75.75h5.738a.75.75 0 0 0 0-1.5H5.236v-2.13c0-1.052.329-2.033.889-2.835l.004-.007a5.03 5.03 0 0 1 4.1-2.2h1.254v7.922c0 .414.336.75.75.75h7.281a.75.75 0 0 0 .75-.75v-2.886a6.47 6.47 0 0 0-.815-3.142C21.032 11.096 22 8.968 22 6.626a1 1 0 0 0-.007-.105 8.3 8.3 0 0 0-.256-1.936.75.75 0 0 0-1.408-.128c-1.137 2.468-3.621 4.345-6.688 4.847l-.02.004h-3.278l.002-.01c-3.064-.502-5.55-2.39-6.688-4.86m12.006 6.787q.219.077.409.168c.43.229.823.518 1.169.858l.034.034c.22.22.423.464.596.716l.003.005c.562.81.89 1.793.89 2.838v2.136h-5.781v-7.16c1.242.043 2.073.191 2.68.405m2.67-.005-.04-.038c-.434-.43-.908-.819-1.546-1.128l-.145-.075a10.3 10.3 0 0 0 3.887-2.955c-.096 1.672-.795 3.21-1.927 4.435a6 6 0 0 0-.23-.239M3.51 7.02a10.36 10.36 0 0 0 3.883 2.952 6.6 6.6 0 0 0-1.955 1.485C4.309 10.23 3.607 8.69 3.51 7.02"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgViking;
